import styled, { css } from "styled-components";

// --- GLOBAL TAG BASE STYLES ---
// Modified to hide the close button by default, allowing overrides for hover.
export const TagBaseStyles = css`
  .custom-tag {
    background: #F1F6FE;
    border: 1px solid #DDE2E9;
    color: #364151;
    border-radius: 20px;
    /* Added 8px padding to the right for space near the close icon when visible */
    padding: 2px 8px 2px 8px; 
    margin: 0 2px;
    white-space: nowrap;
    display: inline-flex; 
    align-items: center;
    cursor: default;
    user-select: none;
    position: relative;
    vertical-align: middle; 
    line-height: 1.5; 
    transition: background-color 0.2s, border-color 0.2s, padding 0.2s;
    font-family: 'Manrope', sans-serif;
    font-size: 13px;
  }

  .custom-tag .tag-close-button {
    font-size: 14px;
    cursor: pointer;
    color: #0C53BB;
    font-weight: bold;
    line-height: 1;
    
    /* NEW: Hide by default */
    opacity: 0; 
    margin-left: 0; 
    padding-left: 0; /* Ensures it doesn't take space when invisible */
    
    transition: opacity 0.2s, margin-left 0.2s, padding-left 0.2s;
  }
  .custom-tag .tag-close-button::after {
    content: "×"; 
  }

`;

// --- (All other non-tag-related exports remain the same) ---

export const EmailSMSConfigWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex: 1;
  overflow: hidden;
  // min-height: 100vh; /* Ensure full viewport height so borders reach the bottom */
  align-items: stretch;
  border: 1px solid #dde2e9;
  border-radius: 6px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const EmailSMSConfigSidebar = styled.div`
  width: 300px;
  height: auto; /* Allow stretching with container */
  background: #fff;
  border-right: 1px solid #DDE2E9;
  margin-left: 0px;
  display: flex;
  flex-direction: column;
  padding: 12px 0;
  overflow-y: auto;
  min-height: 0;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  align-self: stretch; /* Ensure full height alongside content */
  
  @media (max-width: 768px) {
    width: 100%;
    height: 200px;
    border-radius: 6px;
    margin-top: 0;
    margin-bottom: 20px;
  }
  
  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
  
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
`;

export const EmailSMSConfigSidebarItem = styled.div`
  font-family: 'Manrope', sans-serif;
  font-size: 14px;
  line-height: 28px;
  font-weight: ${props => props.active ? 600 : 400};
  background: ${props => props.active ? '#0C53BB' : 'transparent'};
  color: ${props => props.active ? '#fff' : '#5A6C87'};
  border-radius: 6px;
  margin: 0 16px 8px 16px;
  padding: 0 16px;
  height: 40px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  
  &:hover {
    background: ${props => props.active ? '#0C53BB' : '#F3F4F7'};
  }
`;

export const EmailSMSConfigSidebarItemActive = styled.div`
  font-family: 'Manrope', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #0C53BB;
  background: #DAE6F7;
  border-radius: 6px;
  margin: 0 16px 8px 16px;
  padding: 0 16px;
  height: 40px;
  display: flex;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(12,83,187,0.04);
`;

export const EmailSMSConfigSidebarCollapse = styled.div`
  margin: 0 0 8px 0;
`;

export const EmailSMSConfigSidebarCollapseHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: 'Manrope', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #5A6C87;
  background: transparent;
  border-radius: 6px;
  margin: 0 16px;
  padding: 0 16px;
  height: 40px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  white-space: nowrap;
  
  &:hover {
    background: #F3F4F7;
  }
`;


export const EmailSMSConfigSidebarCollapseIcon = styled.img`
  width: 18px;
  height: 18px;
  margin-left: 8px;
  transition: transform 0.2s;
  transform: ${props => props.open ? 'rotate(0deg)' : 'rotate(90deg)'};
`;

export const EmailSMSConfigSidebarSubItem = styled.div`
  font-family: 'Manrope', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #5A6C87;
  background: transparent;
  border-radius: 6px;
  margin: 0 16px 4px 40px;
  padding: 0 16px;
  height: 36px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  
  &:hover:not(.active) {
    background: #F3F4F7;
  }
  
  &.active {
    color: #0C53BB;
    background: #DAE6F7;
    font-weight: 600;
  }
`;


export const EmailSMSConfigContent = styled.div`
  flex: 1;
  background: #fff;
  border-radius: 8px;
  min-width: 400px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  
  @media (max-width: 768px) {
    margin-top: 0;
    min-width: unset;
    width: 100%;
    border-left: 1px solid #DDE2E9;
    border-radius: 8px;
  }
`;

export const EmailSMSConfigContentHeader = styled.div`
  background: #ffffff;
  border-bottom: 1px solid #DDE2E9;
  border-radius: 8px 8px 0 0;
  display: flex;
  align-items: center;
  padding: 0 32px;
  font-family: 'Manrope', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #1B2028;
  justify-content: space-between;
  height: 64px;
  background: #F3F4F733;
`;

export const EmailSMSConfigContentBody = styled.div`
  background: #fff;
  border-radius: 0 0 8px 8px;
  padding: 28px 40px 40px 40px;
  flex: 1;
  overflow-y: auto;
  
  @media (max-width: 768px) {
    padding: 20px 16px;
  }
  
  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
  
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
`;

export const EmailSMSConfigForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const EmailSMSConfigLabel = styled.label`
  font-family: 'Manrope', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #1B2028;
  margin-bottom: 8px;
`;

export const EmailSMSConfigInput = styled.input`
  font-family: 'Manrope', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #364151;
  background: #fff;
  border: 1px solid #DDE2E9;
  border-radius: 6px;
  padding-right: 8px;
  padding-left: 12px;
  height: 40px;
  width: 100%;
  max-width: 600px;
  outline: none;
  margin-bottom: 8px;
  margin-top: 10px;
  transition: border 0.2s;
  &:focus {
    border: 1.5px solid #0C53BB;
  }
`;

export const EmailSubjectConfigInput = styled.input`
  font-family: 'Manrope', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #364151;
  background: #fff;
  border: 1px solid #DDE2E9;
  border-radius: 6px;
  padding-right: 100px; 
  padding-left: 12px;
  height: 40px;
  width: 100%;
  max-width: 600px;
  outline: none;
  margin-bottom: 8px;
  margin-top: 10px;
  transition: border 0.2s;
  &:focus {
    border: 1.5px solid #0C53BB;
  }
`;

// --- SUBJECT EDITABLE DIV (contentEditable) ---
export const SubjectEditableDiv = styled.div`
  ${TagBaseStyles} 

  font-family: 'Manrope', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #364151;
  background: #fff;
  border: 1px solid #DDE2E9;
  border-radius: 6px;
  padding-right: 100px; 
  padding-left: 12px;
  min-height: 40px; 
  line-height: 40px; 
  width: 100%;
  max-width: 600px;
  outline: none;
  margin-bottom: 8px;
  margin-top: 10px;
  transition: border 0.2s;
  cursor: text;
  white-space: nowrap; 
  overflow-x: auto;
  
  &:focus {
    border: 1.5px solid #0C53BB;
    line-height: 1.5; 
    padding-top: 5px; 
    padding-bottom: 5px;
  }
  
  &:empty:not(:focus):before {
    content: attr(placeholder);
    color: #a9a9a9;
    pointer-events: none;
  }
  
  /* Subject-specific HOBVER/Active state for tags */
  .custom-tag:hover {
    background-color: #e6f0ff;
    border-color: #0C53BB;
  }

  .custom-tag:hover .tag-close-button {
    opacity: 1;
    margin-left: 6px;
  }
`;

export const SubjectInputContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 600px;
  margin-top: 10px;
  margin-bottom: 8px;
`;

export const SubjectInsertTagsButton = styled.span`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: #0C53BB;
  font-family: 'Manrope', sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  transition: background 0.2s;
`;

export const SubjectTagsDropdown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 160px;
  margin-top: 4px;
  max-height: 200px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 6px;
    background: #f1f1f1;
  }
  &::-webkit-scrollbar-thumb {
    background: #d1d1d1;
    border-radius: 4px;
  }
  scrollbar-width: thin;
  scrollbar-color: #d1d1d1 #f1f1f1;
`;

export const SubjectTagOption = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  font-size: 13px;
  border-bottom: 1px solid #eee;

  &:hover {
    background-color: #f1f1f1;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const EmailSMSConfigUploadBox = styled.div`
  border: 1px dashed #DDE2E9;
  border-radius: 6px;
  height: 56px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  background: #fff;
  cursor: pointer;
  gap: 12px;
  color: #5A6C87;
  font-family: 'Manrope', sans-serif;
  font-size: 13px;
  font-weight: 500;
  width: 100%;
  max-width: 600px;
  margin-top: 10px;
`;

export const EmailSMSConfigUpdateButton = styled.button`
  width: 70px;
  height: 32px;
  border-radius: 6px;
  background: #0C53BB;
  color: #fff;
  font-family: 'Manrope', sans-serif;
  font-size: 13px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: #084488;
  }
  &:disabled {
    background: #b0c4de;
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

export const EmailSMSPreviewEmailButton = styled.button`
  width: 120px;
  height: 32px;
  border-radius: 6px;
  background: #F3F4F7;
  color: #1B2028;
  font-family: 'Manrope', sans-serif;
  font-size: 13px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
`;

export const EmailSMSConfigUploadSelectedBox = styled.div`
  width: 100%;
  max-width: 600px;
  height: 67px;
  border-radius: 8px;
  border: 1px dashed #0C53BB;
  background: #F1F6FE;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 16px;
  box-sizing: border-box;
  gap: 12px;
`;

export const FieldWrapper = styled.div`
  width: 100%;
  margin-bottom: 20px;
  
  @media (min-width: 768px) {
    width: 70%;
  }
`;

export const EditorWrapper = styled.div`
  width: 100%;
  
  @media (min-width: 768px) {
    width: 65%;
  }
`;

export const QuillContainer = styled.div`
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  overflow: hidden;
  width: 99%;
`;

// --- STYLED EDITOR (QUILL) ---
export const StyledEditor = styled.div`
  ${TagBaseStyles} /* Apply base tag styles */
  
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;

  .editor-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: relative;
    margin-bottom: 4px;
    flex-wrap: wrap;
    gap: 8px;
    
    @media (max-width: 768px) {
      flex-direction: column;
      align-items: stretch;
    }
  }

  .ql-toolbar {
    border: none;
    border-bottom: 1px solid #eee;
    height: 38px;
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
    overflow-x: visible;
    
    @media (max-width: 768px) {
      flex-wrap: wrap;
      height: auto;
      min-height: 38px;
      overflow-x: auto;
    }
  }

  /* Style the size dropdown */
  .ql-toolbar .ql-size {
    width: 100px;
    font-size: 13px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    // padding: 4px 8px;
    margin-right: 8px;
    background: white;
  }

  .ql-toolbar .ql-size:focus {
    border-color: #0c53bb;
    outline: none;
  }

  .ql-container {
    border: none;
    border-top: none;
    min-height: 180px;
    width: 100%;
  }

  .ql-editor {
    padding: 12px;
    width: 100%;
    box-sizing: border-box;
  }

  /* Custom size styling for inline text sizing */
  .ql-editor .ql-size-small {
    font-size: 0.75em;
  }

  .ql-editor .ql-size-normal {
    font-size: 1em;
  }

  .ql-editor .ql-size-large {
    font-size: 1.5em;
    font-weight: 600;
  }

  .ql-editor .ql-size-huge {
    font-size: 2em;
    font-weight: 700;
  }

  .insert-tags-button {
    background: transparent;
    color: #0c53bb;
    font-size: 13px;
    border: none;
    cursor: pointer;
    padding: 4px 8px;
    display: flex;
    align-items: center;
    height: 40px;
    border-radius: 6px;
    transition: background 0.2s;
    white-space: nowrap;
    
    &:hover {
      background: #f8f9fa;
    }
    
    @media (max-width: 768px) {
      width: 100%;
      justify-content: center;
    }
  }

  .insert-tags-dropdown {
    position: absolute;
    top: 36px;
    right: 0;
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    min-width: 160px;
    max-height: 200px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 6px;
      background: #f1f1f1;
    }
    &::-webkit-scrollbar-thumb {
      background: #d1d1d1;
      border-radius: 4px;
    }
    scrollbar-width: thin;
    scrollbar-color: #d1d1d1 #f1f1f1;
    
    @media (max-width: 768px) {
      right: auto;
      left: 0;
      width: 100%;
      min-width: 200px;
    }
  }

  .insert-tag-option {
    background: none;
    border: none;
    width: 100%;
    text-align: left;
    padding: 8px 12px;
    cursor: pointer;
    font-size: 13px;
    border-bottom: 1px solid #eee;
    color: inherit;
    font-family: inherit;
  }

  .insert-tag-option:hover,
  .insert-tag-option:focus {
    background-color: #f1f1f1;
    outline: none;
  }

  .insert-tag-option:last-child {
    border-bottom: none;
  }

  /* EMAIL BODY (QUILL) SPECIFIC TAG OVERRIDES (SHOW CLOSE BUTTON ON HOVER) */
  .ql-editor .custom-tag:hover {
    background-color: #e6f0ff;
    border-color: #0C53BB;
    padding-right: 6px; 
  }

  .ql-editor .custom-tag:hover .tag-close-button {
    opacity: 1; 
    margin-left: 6px; 
  }
`;

// --- PREVIEW AND ERROR STYLES (NO CHANGE) ---

export const ErrorMessageWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 4px;
  gap: 4px;
`;

export const ErrorText = styled.span`
  color: #C63939;
  font-size: 12px;
`;

export const PreviewBox = styled.div`
  width: 600px;
  height: 280px;
  border-radius: 8px;
  border: 1px dashed #0C53BB;
  background: #F1F6FE;
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: hidden;
`;

export const PreviewHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PreviewTitle = styled.div`
  display: flex;
  align-items: center;

  span {
    margin-left: 12px;
  }
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

export const PreviewImageWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0;
`;

export const PreviewImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
`;